
































































import { Component, Mixins } from 'vue-property-decorator';
import { mapGetters } from 'vuex';
import { Actions, Mutations } from '@/ts/store/Constants';
import AddButton from '@/components/Admin/Layout/AddButton.vue';
import AddRoleForm from '@/components/Admin/Forms/AddRoleForm.vue';
import EditRoleForm from '@/components/Admin/Forms/EditRoleForm.vue';
import cloneDeep from 'lodash/cloneDeep';
import UserMethods from '@/mixins/UserMethods.vue';

@Component({
    components: {
        AddButton,
        AddRoleForm,
        EditRoleForm,
    },
    computed: {
        ...mapGetters({
            rolesAndPermissions: 'RolesAndPermissions/getRolesAndPermissions',
            allFeatures: 'RolesAndPermissions/getAllFeatures',
            formVisible: 'Viewport/isAddFormVisible',
        }),
    },
})

export default class RolesAndPermissions extends Mixins(UserMethods) {
    constructor() {
        super();
    }

    get addMenuVisible() {
        return this.$store.getters['Viewport/menuVisible'];
    }

    get addMenuClass() {
        return {
            activeForm: this.addMenuVisible,
        };
    }

    public toggleRoleFeaturePermission(permission: boolean, featureId: number, roleId: number) {
        this.$store.dispatch(Actions.TOGGLE_PERMISSION_ROLE_FEATURE, {permission, featureId, roleId});
    }

    public roleContainsFeature(featureId: number, featuresIds: any) {
        return featuresIds.includes(featureId);
    }

    public roleContainsDefaultFeature(featureId: number, defaultFeaturesIds: any) {
        return defaultFeaturesIds.includes(featureId);
    }

    public setCurrentEditRole(roleId: number) {
        const role = cloneDeep(this.$store.getters['RolesAndPermissions/getRole'](roleId));
        this.$store.commit(Mutations.SET_CURRENT_EDIT_ROLE, role);
        this.$store.dispatch(Actions.SHOW_FORM, 'edit-role');
    }

    public addNewRole() {
        this.$store.dispatch(Actions.SHOW_FORM, 'add-role');
    }

    public created() {
        this.$store.dispatch(Actions.FETCH_PERMISSION_ROLES);
        this.$store.dispatch(Actions.FETCH_PERMISSION_FEATURES);
    }
}
